// third-party
import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

// project imports
import snackbarReducer from "./slices/snackbar";
import menuReducer from "./slices/menu";
import mainReducer from "./slices/Main";
import dropdownReducer from "./slices/Dropdown";
import DashboardAndReports from "./slices/DashboardAndReports";
import PosReportsReducer from "./slices/PosReports";
import AccessManagement from "./slices/AccessManagement";
import BusinessBranches from "./slices/BusinessBranches";
import FirebaseDetails from "./slices/Firebase";
import DeliveryChargesSettings from "./slices/DeliveryChargesSettings";

// ==============================|| COMBINE REDUCER ||============================== //

const reducer = combineReducers({
  dropdown: dropdownReducer,
  global: persistReducer(
    {
      key: "global",
      storage,
      keyPrefix: "ts-",
    },
    mainReducer
  ),
  pos_report_global: persistReducer(
    {
      key: "pos_report_global",
      storage,
      keyPrefix: "ts-",
    },
    PosReportsReducer
  ),
  snackbar: snackbarReducer,
  menu: menuReducer,
  dashboard: DashboardAndReports,
  accessManagement: AccessManagement,
  businessBranches: BusinessBranches,
  firebaseDetails: FirebaseDetails,
  deliveryChargesSettings: DeliveryChargesSettings,
});

export default reducer;
